import { decodeEntities } from "@wordpress/html-entities";

import { useAppContext } from "../AppContext";
import Toggle from "./Toggle";

export default function Sidebar({ className = "" }) {
    const { categoriesFiltered, resourceTypesFiltered, handleToggle, resetFilters, isBusy } =
        useAppContext();

    return (
        <div className={className} onClick={scrollToGridSection}>
            {/* Resource Types */}
            {adw_resource_center?.sidebar_resource_types?.length > 0 && (
                <div className="fw-bold mb-3 text-uppercase">Type</div>
            )}
            {adw_resource_center?.sidebar_resource_types?.map((cat, i) => (
                <Toggle
                    key={i}
                    id={cat?.term_id}
                    labelName={decodeEntities(cat?.name)}
                    cb={({ id }) => handleToggle({ id, taxonomy: "resource_type" })}
                    inputState={resourceTypesFiltered?.includes?.(cat?.term_id)}
                />
            ))}

            {adw_resource_center?.sidebar_categories?.length > 0 && (
                <div className="fw-bold mb-3 mt-4 pt-2 text-uppercase">Category</div>
            )}
            {adw_resource_center?.sidebar_categories?.map((cat, i) => (
                <Toggle
                    key={i}
                    id={cat?.term_id}
                    labelName={decodeEntities(cat?.name)}
                    cb={({ id }) => handleToggle({ id, taxonomy: "category" })}
                    inputState={categoriesFiltered?.includes?.(cat?.term_id)}
                />
            ))}

            <div className="d-flex justify-content-xl-start justify-content-center">
                <a
                    href="#"
                    role="button"
                    disabled={isBusy}
                    className="mt-3 py-2 px-2 d-inline-flex bg-white align-items-center fw-bold text-small btn-outline-secondary text-dark btn-sm shadow-sm rounded-pill"
                    onClick={resetFilters}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="ml-1 bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                    >
                        <path
                            fillRule="evenodd"
                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                    </svg>
                    <span className="mx-2 text-small">Reset</span>
                </a>
            </div>
        </div>
    );
}

function scrollToGridSection(e) {
    e.stopPropagation();

    $("html, body").animate(
        {
            scrollTop: $(".filterable-grid-for-hub").offset().top - 100,
        },
        500,
        "linear",
    );
}
